/** Os sete textos do procedimento de emergência de um perigo; `null` é campo vazio. */
export const CAMPOS_DO_PROCEDIMENTO_DE_EMERGENCIA = [
  'procedimentos',
  'meios',
  'recursos',
  'encaminhamento',
  'responsaveis',
  'vazamento',
  'incendio',
] as const;

export type CampoDoProcedimentoDeEmergencia = (typeof CAMPOS_DO_PROCEDIMENTO_DE_EMERGENCIA)[number];

export type ProcedimentoDeEmergencia = Record<CampoDoProcedimentoDeEmergencia, string | null>;

export const LIMITE_DO_TEXTO_DE_EMERGENCIA = 5000;
